import React from 'react';
import './LogoCarousel.css';
import b1 from '../images/b1.png';
import b2 from '../images/b2.png';
import b3 from '../images/b3.png';
import b4 from '../images/b4.png';
import b5 from '../images/b5.png';

// Import the logo images (you'll need to add these to your images folder)
// For now, I'll use the provided images as base64 or you can save them to src/images/
const logos = [
  {
    id: 1,
    name: 'CIGSIDA',
    src: b1,
    alt: 'CIGSIDA Logo'
  },
  {
    id: 2,
    name: 'Université Ibn Zohr',
    src: b3,
    alt: 'Université Ibn Zohr Logo'
  },
     {
    id: 3,
    name: 'IAMAR',
    src: b2,
    alt: 'IAMAR Logo',
    href: 'https://iamar.ma/'
  },
  
  {
    id: 4,
    name: 'LARLANCO',
    src: b4,
    alt: 'LARLANCO Logo'
  },
 
  
  // {
  //   id: 5,
  //   name: 'hermanas',
  //   src: b5,
  //   alt: 'hermanas Logo'
  // },

  
];

function LogoCarousel() {
  return (
    <div className="logo-carousel">
      <div className="carousel-container">
        <div className="carousel-track">
          {/* First set of logos */}
          {logos.map((logo) => (
            <div key={`first-${logo.id}`} className="logo-slide">
              {logo.href ? (
                <a href={logo.href} target="_blank" rel="noopener noreferrer" aria-label={logo.name}>
                  <img src={logo.src} alt={logo.alt} />
                </a>
              ) : (
                <img src={logo.src} alt={logo.alt} />
              )}
            </div>
          ))}
          {/* Duplicate set for seamless loop */}
          {logos.map((logo) => (
            <div key={`second-${logo.id}`} className="logo-slide">
              {logo.href ? (
                <a href={logo.href} target="_blank" rel="noopener noreferrer" aria-label={logo.name}>
                  <img src={logo.src} alt={logo.alt} />
                </a>
              ) : (
                <img src={logo.src} alt={logo.alt} />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LogoCarousel;
